import { gql } from '@apollo/client';

export const PICTURE_FIELDS = gql`
  fragment PictureFields on Picture {
    id
    createdAt
    updatedAt
    name
    sensitive
    caption
    path
    path256
    path512
    overlayPath
    overlayPath256
    overlayPath512
    thumbhash
    index
    topicId
    typeId
    topic {
      id
      name
      typeId
    }
  }
`;
